module.exports = __webpack_public_path__ + "static/media/beddingBag.c19f90e6.svg";